function defaultCallback(el, e) {
  el?.classList.remove("open");
}

export function onClickOutsideElement(elem, callback = defaultCallback) {
  function outsideClickListener(event) {
    if (!elem.contains(event.target)) {
      callback(elem, event);
      document.removeEventListener("click", outsideClickListener);
    }
  }

  document.addEventListener("click", outsideClickListener);
}
